import { Box, Button, Popover, Typography } from "@material-ui/core";
import { FC, ReactElement, ReactNode, useState } from "react";

import { ButtonColor, ButtonSize, ButtonVariant, GenericFunction } from "../types/generic.types";

const ConfirmationPopover: FC<ConfirmationPopoverProps> = ({
  onConfirm,
  message,
  subMessage,
  buttonText = null,
  buttonColor = "primary",
  buttonVariant = "contained",
  buttonSize = "small",
  buttonStartIcon,
  confirmationText = "Confirm",
  confirmationColor = "primary",
  confirmationVariant = "contained",
  disabled = false,
  Icon,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    event.stopPropagation();
    if (disabled) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        <Box p={2}>
          <Typography>{message}</Typography>
          {subMessage ? (
            <Typography variant="caption" color="textSecondary">
              {subMessage}
            </Typography>
          ) : null}
          <Box display="flex" justifyContent="flex-end" pt={2}>
            <Button
              color={confirmationColor}
              variant={confirmationVariant}
              size="small"
              onClick={(e) => {
                onConfirm();
                handleClose(e);
              }}
            >
              {confirmationText}
            </Button>
          </Box>
        </Box>
      </Popover>

      <Box onClick={handleClick} style={{ opacity: disabled ? 0.5 : 1 }}>
        {Icon ?? (
          <Button color={buttonColor} variant={buttonVariant} size={buttonSize} startIcon={buttonStartIcon}>
            {buttonText}
          </Button>
        )}
      </Box>
    </>
  );
};

interface ConfirmationPopoverProps {
  onConfirm: GenericFunction;
  message: string;
  subMessage?: string | null;
  buttonText?: string | null;
  buttonColor?: ButtonColor;
  buttonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  buttonStartIcon?: ReactNode;
  confirmationText?: string;
  confirmationColor?: ButtonColor;
  confirmationVariant?: ButtonVariant;
  disabled?: boolean;
  Icon?: ReactElement;
}

export default ConfirmationPopover;
